// RİZOMLU BİTKİLER - bitkiVeritabani5.js
// Anubias, Java Fern, Bucephalandra, Bolbitis (29 bitki)

export const rizomluBitkiler = [
  // ==================== ANUBIAS (Low Tech) ====================
  {
    id: 'anubias-barteri-nana',
    isim: 'Cüce Anubias',
    latince: 'Anubias barteri var. nana',
    resim: '/images/bitkiler/anubias-barteri-nana.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '5-15 cm',
    genislik: '8-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Çok kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'En popüler Anubias. Taş veya kütüğe bağlanır. Gölgeye dayanıklı.'
  },
  {
    id: 'anubias-barteri-nana-petite',
    isim: 'Mini Anubias',
    latince: 'Anubias barteri var. nana Petite',
    resim: '/images/bitkiler/anubias-barteri-nana-petite.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '3-5 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön plan',
    aciklama: 'En küçük Anubias türü. Nano akvaryumlar için ideal.'
  },
  {
    id: 'anubias-barteri-nana-golden',
    isim: 'Altın Anubias',
    latince: 'Anubias barteri var. nana Golden',
    resim: '/images/bitkiler/anubias-barteri-nana-golden.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '5-10 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Sarımsı-yeşil yapraklı dekoratif varyant.'
  },
  {
    id: 'anubias-barteri-nana-marble',
    isim: 'Mermer Anubias',
    latince: 'Anubias barteri var. nana Marble',
    resim: '/images/bitkiler/anubias-barteri-nana-marble.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '5-10 cm',
    genislik: '8-12 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Beyaz-yeşil alacalı yapraklı nadir varyant.'
  },
  {
    id: 'anubias-barteri-barteri',
    isim: 'Anubias Barteri',
    latince: 'Anubias barteri var. barteri',
    resim: '/images/bitkiler/anubias-barteri-barteri.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Çok kolay',
    konum: 'Orta plan',
    aciklama: 'Orta boyutlu klasik Anubias. Çok dayanıklı.'
  },
  {
    id: 'anubias-barteri-angustifolia',
    isim: 'Dar Yapraklı Anubias',
    latince: 'Anubias barteri var. angustifolia',
    resim: '/images/bitkiler/anubias-barteri-angustifolia.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '10-20 cm',
    genislik: '10-15 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Uzun dar yapraklı zarif tür.'
  },
  {
    id: 'anubias-barteri-caladiifolia',
    isim: 'Kalp Yapraklı Anubias',
    latince: 'Anubias barteri var. caladiifolia',
    resim: '/images/bitkiler/anubias-barteri-caladiifolia.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '20-40 cm',
    genislik: '20-35 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Büyük kalp şeklinde yapraklar.'
  },
  {
    id: 'anubias-barteri-coffeefolia',
    isim: 'Kahve Yapraklı Anubias',
    latince: 'Anubias barteri var. coffeefolia',
    resim: '/images/bitkiler/anubias-barteri-coffeefolia.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '15-25 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Dalgalı kahverengi-yeşil yapraklar. Çok dekoratif.'
  },
  {
    id: 'anubias-barteri-glabra',
    isim: 'Parlak Anubias',
    latince: 'Anubias barteri var. glabra',
    resim: '/images/bitkiler/anubias-barteri-glabra.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '15-30 cm',
    genislik: '10-20 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Uzun saplı, parlak yeşil yapraklar.'
  },
  {
    id: 'anubias-afzelii',
    isim: 'Afzeli Anubias',
    latince: 'Anubias afzelii',
    resim: '/images/bitkiler/anubias-afzelii.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '25-50 cm',
    genislik: '20-35 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Uzun mızrak şeklinde yapraklar.'
  },
  {
    id: 'anubias-gigantea',
    isim: 'Dev Anubias',
    latince: 'Anubias gigantea',
    resim: '/images/bitkiler/anubias-gigantea.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '50-100 cm',
    genislik: '40-60 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'En büyük Anubias türü. Sadece büyük akvaryumlar için.'
  },
  {
    id: 'anubias-heterophylla',
    isim: 'Değişken Yapraklı Anubias',
    latince: 'Anubias heterophylla',
    resim: '/images/bitkiler/anubias-heterophylla.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '30-50 cm',
    genislik: '25-40 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Arka plan',
    aciklama: 'Uzun dalgalı kenarlı yapraklar.'
  },
  {
    id: 'anubias-hastifolia',
    isim: 'Ok Yapraklı Anubias',
    latince: 'Anubias hastifolia',
    resim: '/images/bitkiler/anubias-hastifolia.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '25-40 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Ok ucu şeklinde yapraklar.'
  },
  {
    id: 'anubias-gracilis',
    isim: 'Zarif Anubias',
    latince: 'Anubias gracilis',
    resim: '/images/bitkiler/anubias-gracilis.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Batı Afrika',
    uzunluk: '20-40 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Üçgen şeklinde zarif yapraklar.'
  },
  {
    id: 'anubias-gilletii',
    isim: 'Gilletti Anubias',
    latince: 'Anubias gilletii',
    resim: '/images/bitkiler/anubias-gilletii.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Orta Afrika',
    uzunluk: '20-35 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Kalp şeklinde yaprakları ile nadir tür.'
  },
  {
    id: 'anubias-frazeri',
    isim: 'Frazeri Anubias',
    latince: 'Anubias frazeri',
    resim: '/images/bitkiler/anubias-frazeri.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu (Hibrit)',
    uzunluk: '20-35 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Dalgalı kenarlı geniş yapraklı hibrit.'
  },

  // ==================== JAVA FERN (Microsorum) ====================
  {
    id: 'microsorum-pteropus',
    isim: 'Java Eğreltisi',
    latince: 'Microsorum pteropus',
    resim: '/images/bitkiler/microsorum-pteropus.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '15-35 cm',
    genislik: '15-25 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Çok kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Klasik akvaryum bitkisi. Taş veya kütüğe bağlanır.'
  },
  {
    id: 'microsorum-pteropus-windelov',
    isim: 'Windelov Java',
    latince: 'Microsorum pteropus Windelov',
    resim: '/images/bitkiler/microsorum-pteropus-windelov.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-25 cm',
    genislik: '15-25 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Yaprak uçları çatallı, çok dekoratif.'
  },
  {
    id: 'microsorum-pteropus-narrow',
    isim: 'Dar Yapraklı Java',
    latince: 'Microsorum pteropus Narrow',
    resim: '/images/bitkiler/microsorum-pteropus-narrow.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-30 cm',
    genislik: '10-20 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'İnce uzun yapraklı zarif form.'
  },
  {
    id: 'microsorum-pteropus-needle-leaf',
    isim: 'İğne Yapraklı Java',
    latince: 'Microsorum pteropus Needle Leaf',
    resim: '/images/bitkiler/microsorum-pteropus-needle-leaf.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '10-20 cm',
    genislik: '10-15 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Ön - Orta plan',
    aciklama: 'Çok ince iğne gibi yapraklar.'
  },
  {
    id: 'microsorum-pteropus-trident',
    isim: 'Trident Java',
    latince: 'Microsorum pteropus Trident',
    resim: '/images/bitkiler/microsorum-pteropus-trident.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Çatallı yapraklar, kompakt büyüme.'
  },
  {
    id: 'microsorum-pteropus-philippine',
    isim: 'Filipin Java',
    latince: 'Microsorum pteropus Philippine',
    resim: '/images/bitkiler/microsorum-pteropus-philippine.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Filipinler',
    uzunluk: '20-40 cm',
    genislik: '20-30 cm',
    sicaklik: '22-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta - Arka plan',
    aciklama: 'Dalgalı kenarlı geniş yapraklar.'
  },
  {
    id: 'microsorum-pteropus-tropica',
    isim: 'Tropica Java',
    latince: 'Microsorum pteropus Tropica',
    resim: '/images/bitkiler/microsorum-pteropus-tropica.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Low Tech',
    habitat: 'Kültür formu',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Orta plan',
    aciklama: 'Parçalı yapraklar, yoğun görünüm.'
  },

  // ==================== BUCEPHALANDRA ====================
  {
    id: 'bucephalandra-pygmaea',
    isim: 'Cüce Bucephalandra',
    latince: 'Bucephalandra pygmaea',
    resim: '/images/bitkiler/bucephalandra-pygmaea.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Borneo',
    uzunluk: '3-8 cm',
    genislik: '5-10 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan',
    aciklama: 'Küçük yapraklı, mavi-yeşil renkli nadir bitki.'
  },
  {
    id: 'bucephalandra-sordidula',
    isim: 'Sordidula Bucephalandra',
    latince: 'Bucephalandra sordidula',
    resim: '/images/bitkiler/bucephalandra-sordidula.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Borneo',
    uzunluk: '5-10 cm',
    genislik: '5-12 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön - Orta plan',
    aciklama: 'Koyu yeşil dalgalı yapraklar.'
  },

  // ==================== DİĞER RİZOMLU BİTKİLER ====================
  {
    id: 'bolbitis-heudelotii',
    isim: 'Afrika Su Eğreltisi',
    latince: 'Bolbitis heudelotii',
    resim: '/images/bitkiler/bolbitis-heudelotii.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Afrika',
    uzunluk: '15-40 cm',
    genislik: '15-25 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.0',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Koyu yeşil parçalı yapraklar. Su akıntısını sever.'
  },
  {
    id: 'barclaya-longifolia',
    isim: 'Barclaya',
    latince: 'Barclaya longifolia',
    resim: '/images/bitkiler/barclaya-longifolia.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '25-50 cm',
    genislik: '20-35 cm',
    sicaklik: '24-28°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Orta',
    konum: 'Orta - Arka plan',
    aciklama: 'Kırmızı-yeşil dalgalı yapraklar. Su altında çiçek açabilir.'
  },
  {
    id: 'hymenasplenium-obscurum',
    isim: 'Hymenasplenium',
    latince: 'Hymenasplenium obscurum',
    resim: '/images/bitkiler/hymenasplenium-obscurum.jpg',
    kategori: 'Rizomlu Bitkiler',
    techSeviye: 'Mid Tech',
    habitat: 'Asya',
    uzunluk: '10-25 cm',
    genislik: '10-20 cm',
    sicaklik: '20-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Orta plan',
    aciklama: 'Tüysü yapraklı nadir eğrelti türü.'
  }
];

export default rizomluBitkiler;